export const environment = {
    production: false,
    api: 'https://sig-mtm-we-apim-dev.azure-api.net/api',
    webview: 'https://sig-mtm-we-apim-dev.azure-api.net/api/v1',
    apiKey:"30084d53e413449caaaca0f41d08c8aa",
    userRole: "SUPERADMIN",
    clientId: '819d2d23-e8b8-43ad-87c7-140cfd8180e5',
    authority:'https://sigvarisgroupcust.b2clogin.com/sigvarisgroupcust.onmicrosoft.com/B2C_1_mtmapp_signin_uat',
    redirectUri: 'https://test.mtmapp.sigvaris.com/login-successfully',
    postLogoutRedirectUri: 'https://test.mtmapp.sigvaris.com',
    knownAuthorities: ['sigvarisgroupcust.b2clogin.com'],
}